import React, { useContext, useEffect, useRef, useState } from "react";
import UserContext from "../../../contexts/UserContext";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import { NavLink, useLocation } from "react-router-dom";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import OwLabel from "../../shared/OwLabel/OwLabel";
import INotification from "../../../models/INotification";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
};

export const VendorSourcesHeader: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const location = useLocation();

    const [vendorBtnClassName, setVendorBtnClassName] = useState("");
    const [vendorUserBtnClassName, setVendorUserBtnClassName] = useState("");
    const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumbs[]>([]);
    const [activeStyle, setActiveStyle] = useState({ fontWeight: "bold", color: "#FFF", borderBottom: "1px solid white" });
    const [inactiveStyle, setInactiveStyle] = useState({ fontWeight: "bold", color: "#EEE" });
    const [vendorLinkTo, setVendorLinkTo] = useState("/vendor_sources");
    const [vendorUsersLinkTo, setVendorUsersLinkTo] = useState("/vendor_sources/users");

    const customersRef = useRef<HTMLAnchorElement | null>(null);
    const customerUsersRef = useRef<HTMLAnchorElement | null>(null);

    const setupBreadcrumbs = () => {
        const _breadcrumbs: IBreadcrumbs[] = [{ title: "purchase_orders", url: "/purchase_orders" }];

        switch (location.pathname) {
            case "/vendor_sources":
                {
                    setVendorBtnClassName("active");
                    _breadcrumbs.push({ title: "vendor_sources", url: "/vendor_sources" });
                }
                break;

            case "/vendor_sources/users":
                {
                    setVendorUserBtnClassName("active");
                    _breadcrumbs.push({ title: "vendor_sources_users", url: "/vendor_sources/users" });
                }
                break;
        }

        setBreadcrumbs(_breadcrumbs);
    };

    useEffect(() => {
        setupBreadcrumbs();
    }, []);

    useEffect(() => {
        setupBreadcrumbs();
    }, [location]);

    const clickNavLink = (linkName: string) => {
        if (linkName === "vendor_sources" && customersRef) {
            // @ts-expect-error
            // customersRef.click();
        }

        if (linkName === "vendor_sources_users" && customerUsersRef) {
            // @ts-expect-error
            // customerUsersRef.click();
        }
    };

    return (
        <div className={"AccountsHeader"}>
            <Breadcrumbs navItems={breadcrumbs} />

            <div className={"row mt-4"}>
                <div className={"col-12 d-flex"}>
                    <div className={"btn-group"}>
                        <button
                            className={"btn btn-primary " + vendorBtnClassName}
                            onClick={() => {
                                clickNavLink("vendor_sources");
                            }}>
                            <NavLink
                                ref={customersRef}
                                // exact={true}
                                style={inactiveStyle}
                                // activeStyle={activeStyle}
                                // activeClassName={"active"}
                                to={vendorLinkTo}>
                                <OwLabel noBottomMargin={true} title={"vendor_sources"} className={"pointer"} />
                            </NavLink>
                        </button>
                        {supplierModel.has_customer_module ? (
                            <button
                                className={"btn btn-primary " + vendorUserBtnClassName}
                                onClick={() => {
                                    clickNavLink("vendor_sources_users");
                                }}>
                                <NavLink
                                    ref={customerUsersRef}
                                    // exact={true}
                                    style={inactiveStyle}
                                    // activeStyle={activeStyle}
                                    // activeClassName={"active"}
                                    to={vendorUsersLinkTo}>
                                    <OwLabel noBottomMargin={true} className={"pointer"} title={"vendor_sources_users"} />
                                </NavLink>
                            </button>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};
